const ruleSeparator = ':';
const paramSeparator = ',';

const component = {
    data() {
        const that = this

        const rulesMap = {
            /**
             * 必填校验
             * @author  韦胜健
             * @date    2019/10/25 14:32
             */
            required(val, params) {
                return {validate: !!val || val === 0, msg: that.$lv.$t('LinkInput.requireText'),}
            },
            /**
             * 长度校验
             * @author  韦胜健
             * @date    2019/10/25 14:32
             */
            length(val, params) {
                let max, min;
                if (!params) {
                    console.error('length校验必须指定最大长度或者最小长度！')
                    return
                }
                if (that.$lv.$utils.typeOf(params) === 'array') {
                    min = params[0] === '?' ? null : params[0]
                    max = params[1] === '?' ? null : params[1]
                } else {
                    min = params.min
                    max = params.max
                }

                if (!!min && (!val || val.length < (min - 0))) return {validate: false, msg: that.$lv.$t('LinkValidateService.lengthCannotBeLessThan', {min})}
                if (!!max && !!val && val.length > (max - 0)) return {validate: false, msg: that.$lv.$t('LinkValidateService.lengthCannotBeLargeThan', {max})}
                return {validate: true}
            },
            /**
             * 邮箱校验
             * @author  韦胜健
             * @date    2019/10/25 14:32
             */
            email(val, params) {
                if (!val) return {validate: true}
                const regexp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                const flag = regexp.test(val)
                return {validate: flag, msg: flag ? null : that.$lv.$t('LinkValidateService.incorrectEmail'),}
            },
            /**
             * 电话号码校验
             * @author  韦胜健
             * @date    2019/10/25 14:33
             */
            phone(val, params) {
                if (!val) return {validate: true}
                const regexp = /^1[3456789]\d{9}$/;
                const flag = regexp.test(val)
                return {validate: flag, msg: flag ? null : that.$lv.$t('LinkValidateService.incorrectPhoneNumber'),}
            },
            /**
             * qq号码校验
             * @author  韦胜健
             * @date    2019/10/25 14:33
             */
            qq(val, params) {
                if (!val) return {validate: true}
                const regexp = /^[1-9][0-9]{4,9}$/;
                const flag = regexp.test(val)
                return {validate: flag, msg: flag ? null : that.$lv.$t('LinkValidateService.incorrectQQNum'),}
            },
            /**
             * 省份证号校验
             * @author  韦胜健
             * @date    2019/10/25 14:33
             */
            cardId(val, params) {
                if (!val) return {validate: true}
                const regexp15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
                const regexp18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

                const flag = regexp15.test(val) || regexp18.test(val)
                return {validate: flag, msg: flag ? null : that.$lv.$t('LinkValidateService.incorrectIdCard'),}
            },
            /**
             * 正则校验
             * @author  韦胜健
             * @date    2019/10/25 14:33
             */
            regexp(val, params) {
                if (!val) return {validate: true}
                let reg, msg
                if (that.$lv.$utils.typeOf(params) === 'array') {
                    msg = params[0]
                    reg = new RegExp(params[1])
                } else {
                    msg = params.msg
                    reg = params.reg
                }
                const flag = reg.test(val)
                return {validate: flag, msg: flag ? null : msg}
            },
            /**
             * 数字校验
             * @author  韦胜健
             * @date    2019/10/25 14:33
             */
            number(val, params) {
                if (!val) return {validate: true}
                let {max, min} = params
                if (isNaN(val)) {
                    return {validate: false, msg: that.$lv.$t('LinkValidateService.pleaseEnterCorrectNumber'),}
                }
                if (max != null && val > max) {
                    return {validate: false, msg: that.$lv.$t('LinkValidateService.maxNumber', {max}),}
                }
                if (min != null && val < min) {
                    return {validate: false, msg: that.$lv.$t('LinkValidateService.minNumber', {min}),}
                }
                return {validate: true, msg: null}
            },
        }
        return {
            rulesMap,
        }
    },
    methods: {
        formatRule(rules, rulesMap) {
            const ruleNames = Object.keys(rulesMap)

            return rules.map(rule => {
                let ruleSeparatorIndex, ruleName, ruleNameIndex, paramString, param, execute
                switch (this.$lv.$utils.typeOf(rule)) {
                    case 'string':
                        ruleSeparatorIndex = rule.indexOf(ruleSeparator)
                        if (ruleSeparatorIndex === -1) {
                            ruleName = rule
                        } else {
                            ruleName = ruleSeparatorIndex > -1 ? rule.substring(0, ruleSeparatorIndex) : rule
                        }

                        if (!rulesMap[ruleName]) {
                            console.error('校验规则不存在！' + ruleName + '，目前校验规则：' + ruleNames.join(','))
                            return null
                        } else {
                            execute = rulesMap[ruleName]
                        }

                        paramString = rule.substring(ruleSeparatorIndex + 1, rule.length)
                        if (!!paramString) {
                            if (/[^{]}$/.test(paramString)) {
                                param = ruleSeparatorIndex > -1 ? this.$lv.$utils.parseJson(paramString) : {}
                            } else {
                                param = paramString.split(paramSeparator)
                            }
                        }
                        return {
                            rule: ruleName,
                            param: param,
                            execute,
                        }
                    case 'object':
                        let ret = rule
                        ruleNameIndex = ruleNames.indexOf(ret.rule)
                        if (!rulesMap[ret.rule]) {
                            console.error(`校验规则不存在“${ret.rule}”`)
                            return null
                        } else {
                            execute = rulesMap[ret.rule]
                        }

                        return {
                            rule: ret.rule,
                            param: Object.keys(ret).reduce((r, key) => {
                                key !== 'rule' && (r[key] = ret[key])
                                return r
                            }, {}),
                            execute,
                        }
                }
            })
        },
        validate(val, required, rules, externalRuleMap) {
            rules = rules || []
            const rulesMap = Object.assign({}, this.rulesMap, externalRuleMap)

            this.$lv.$utils.typeOf(rules) !== 'array' && (rules = [rules])
            !!required && rules.push('required')

            rules = this.formatRule(rules, rulesMap)
            for (let i = 0; i < rules.length; i++) {
                const rule = rules[i];
                let ret = rule.execute(val, rule.param)
                if (!ret.validate) return ret
            }
            return null
        },
    }
}

class ValidateService extends Vue {
    constructor() {
        super(component)
    }
}

export default ValidateService
